import LightGallery from 'lightgallery/react';
import './Gal.css';

// import styles
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-autoplay.css';
import 'lightgallery/css/lg-fullscreen.css';
import 'lightgallery/css/lg-share.css';
import 'lightgallery/css/lg-rotate.css';


// import plugins if you need
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import lgAutoplay from 'lightgallery/plugins/autoplay'
import lgFullscreen from 'lightgallery/plugins/fullscreen';
import lgShare from 'lightgallery/plugins/share';
import lgRotate from 'lightgallery/plugins/rotate';

const images = [
    { src: "images/Ba38/Ba 38 (1).jpg", alt: "1" },
    { src: "images/Ba38/Ba 38 (2).jpg", alt: "2" },
    { src: "images/Ba38/Ba 38 (3).jpg", alt: "3" },
    { src: "images/Ba38/Ba 38 (4).jpg", alt: "4" },
    { src: "images/Ba38/Ba 38 (5).jpg", alt: "5" },
    { src: "images/Ba38/Ba 38 (6).jpg", alt: "6" },
   
    
    
]

function Galo38() {
    const onInit = () => {
        console.log('lightGallery has been initialized');
    };
    return (
        <div className="gallery-container">
         <h1>BAM 33- TWO FLOOR HOUSE</h1>
            <p className='about'>This Model House Includes 4 Bedrooms, 2 Bathrooms, A LIving Area, A Dining Area, A kitchen And A Car Porch
            </p>
            <p className='about'>Price LKR 12.5 Million</p>
            <LightGallery
                onInit={onInit}
                speed={500}
                plugins={[lgThumbnail, lgZoom, lgAutoplay, lgFullscreen, lgRotate, lgShare]}
            >

                {images.map((image, index) => {
                    return (
                        <a href={image.src} key={index}>
                            <img alt={image.alt} src={image.src} />
                        </a>
                    )
                })}


            </LightGallery>
        </div>
    );
}
export default Galo38;
